import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { LocalDataSource } from "ng2-smart-table";
import * as moment from "moment";
import { BudgetService } from "../../services/budget.service";
import { NotifierService } from "../../shared/notifier/notifier.service";
import { Router, ActivatedRoute } from "@angular/router";
import { MatDialog } from "@angular/material";
import { AlertComponent } from "../../../shared";
import * as fileSaver from "file-saver";
import { ReportesService } from "../../services/reportes.service";
import { IWorkOrder } from "../../work-order/new-work-order/new-work-order.component";
import "rxjs/add/operator/filter";
import { WorkOrderService } from "../../services/work-order.service";
import { isEmpty } from "rxjs/operator/isEmpty";
import { ListofvaluesService } from "../../services/listofvalues.service";
import { resolve } from "path";
import { map, startWith } from "rxjs/operators";
import { Observable } from "rxjs";
import { NgForm, FormControl } from "@angular/forms";
import { BillingService } from "../../services/billing.service";
import { v } from "@angular/core/src/render3";
import { UserService } from "../../services/usuario.service";

@Component({
  selector: "app-budget-list",
  templateUrl: "budget-list.component.html",
  styleUrls: ["budget-list.component.scss"],
  encapsulation: ViewEncapsulation.None,
  providers: [
    BudgetService,
    WorkOrderService,
    ListofvaluesService,
    ReportesService,
    BillingService,
    UserService,
  ],
})
export class BudgetListComponent implements OnInit {
  selectedRows: any = [];
  tableSettingsBudgetHeader: any = undefined;
  dataSourceBudgetHeader: any = undefined;
  tableDataBudgetHeader: any = {};
  ldvStates: any = {};
  params: any = {};
  wo_id: number;
  currentId: number;
  currentCode: string;

  dataEstado;
  montototal = 0;

  work_orders: Array<any> = [];
  select_wo: boolean = false;
  todos_activo = true;
  vigentes_activo = false;
  vencidos_activo = false;
  archivados_activo = false;
  showArchived = false;
  woFilterCode = "";
  perPage = 10;
  settings = {
    selectMode: "multi",
    pager: { display: true, perPage: this.perPage },
    noDataMessage: "No hay datos que mostrar.",
    columns: undefined,
    actions: {
      add: false,
      delete: false,
      position: "right",
      edit: false,
      columnTitle: "Acciones",
      custom: [],
    },
  };

  myControlOrders = new FormControl();
  options: string[] = [];
  filteredOrders: Observable<string[]>;

  rolParaValidar: any = Number(localStorage.getItem('rolIdUser'));

  constructor(
    private reporteService: ReportesService,
    private budgetService: BudgetService,
    private workOrderService: WorkOrderService,
    private listofvalueService: ListofvaluesService,
    private notifierService: NotifierService,
    private routes: Router,
    private activedRoutes: ActivatedRoute,
    private billingService: BillingService,
    private userService: UserService,
    private dialog: MatDialog
  ) {
    this.params = this.activedRoutes.params;
    this.wo_id = this.params.value.id;

    this.userService.obtenerDatosPersonales().subscribe((personal: any) => {
      //console.log('PERSONAL :: ', personal);
      this.rolParaValidar = personal.rol;

      this.settings.actions.custom = [];
      this.settings.actions.custom.push({
        name: "editar",
        title: `<div class="editCustomButton">Editar</div>`,
      });
      if (this.rolParaValidar == 4 || this.rolParaValidar == 5) {
        this.settings.actions.custom.push({
          name: "eliminar",
          title: `<div class="editCustomButton">Eliminar</div>`,
        });
        this.settings.actions.custom.push({
          name: "archivar",
          title: `<div class="editCustomButton">Archivar</div>`,
        });
      }
    });

    this.workOrderService
      .getAllWorkOrders(0)
      .subscribe((result: Array<any>) => {
        this.work_orders = result;
        this.work_orders.forEach((element) => {
          this.options.push(element.external_code);
        });

        this.filteredOrders = this.myControlOrders.valueChanges.pipe(
          startWith(""),
          map((value) => this._filter(value, this.options))
        );
      });

    this.listofvalueService
      .getLdvByCode("TBWA-STATE-BUDGET")
      .subscribe((result) => {
        this.ldvStates = result;
        this.dataEstado = [];

        this.ldvStates.forEach((element) => {
          this.dataEstado.push({
            value: element["value"],
            title: element["value"],
          });
        });

        this.tableDataBudgetHeader = {
          columns: {
            external_code: { title: "Codigo" },
            work_order_external_code: { title: "OT Rel." },
            project: { title: "Proyecto" },
            state_name: {
              title: "Estado",
              filter: {
                type: "list",
                config: {
                  selectText: "Seleccionar",
                  list: this.dataEstado,
                },
              },
            },
            facts: { title: "Factura" },
            client_name: { title: "Cliente" },
            monto_final: { title: "Monto" },
            user_name: { title: "Creado por" },
          },
          data: {},
        };

        //console.log(this.tableDataBudgetHeader);
      });
  }

  private _filter(value: string, options): string[] {
    const filterValue = value.toLowerCase();

    return options.filter((option) =>
      option.toLowerCase().includes(filterValue)
    );
  }

  ngOnInit() {
    if (this.wo_id) {
      this.budgetService.getBudgetsByWorkOrderId(this.wo_id).subscribe(
        (result: any) => {
          this.currentId = this.wo_id;
          this.select_wo = true;
          const found = this.work_orders.find((item) => {
            // tslint:disable-next-line:triple-equals
            return item.id == this.wo_id;
          });
          this.currentCode = found.external_code;
          this.getTableData(result);
          this.cargarTodos();
        },
        (error) => {
          this.getTableData([]);
        }
      );
    } else {
      this.budgetService.getBudgets().subscribe(
        (result) => {
          //     this.getTableData(result);
          this.cargarTodos();
        },
        (error) => {
          this.getTableData([]);
        }
      );
    }
  }

  /*getWorkOrders(event?) {
    if (event) {
      this.woFilterCode = event.target.value
    }
    this.projectService.getProjectsByName(this.woFilterCode)
      .subscribe(
        result => {
          this.work_orders = result as Array<any>
        },
        error => {
          console.log('error', error)
        }
      )
  }*/

  newBudget() {
    const found = this.work_orders.find((item) => {
      // tslint:disable-next-line:triple-equals
      return item.external_code == this.currentCode;
    });
    this.currentId = found.id;
    this.routes.navigate(["system/budget/new/" + this.currentId]);
  }

  cargarTodos() {
    this.todos_activo = true;
    this.vigentes_activo = false;
    this.vencidos_activo = false;
    this.showArchived = false;

    var todos = [];

    this.budgetService.getBudgets().subscribe((resultBudgets: any) => {
      this.dataSourceBudgetHeader = resultBudgets;
      this.dataSourceBudgetHeader = [];

      this.dataSourceBudgetHeader = resultBudgets.filter(
        (budget) => budget.state != 9
      );

      this.settings.actions.custom = [];

      // Cuentas no debe acceder
      this.settings.actions.custom.push({
        name: "editar",
        title: `<div class="editCustomButton">Editar</div>`,
      });
      if (this.rolParaValidar == 4 || this.rolParaValidar == 5) {
        this.settings.actions.custom.push({
          name: "eliminar",
          title: `<div class="editCustomButton">Eliminar</div>`,
        });
        this.settings.actions.custom.push({
          name: "archivar",
          title: `<div class="editCustomButton">Archivar</div>`,
        });
      }

      this.dataSourceBudgetHeader.map((element) => {
        if (element.dias > 60) {
          element.colorAviso = "r-rojo";
        }
      });
      this.getTableData(this.dataSourceBudgetHeader);
    });
  }

  cargarVigentes() {
    localStorage.setItem(
      "filter-budget",
      JSON.stringify(this.dataSourceBudgetHeader.getFilter())
    );
    this.todos_activo = false;
    this.vigentes_activo = true;
    this.vencidos_activo = false;
    this.showArchived = false;

    var vigentes = [];

    this.dataSourceBudgetHeader = [];

    this.budgetService.getBudgets().subscribe((resultBudgets: any) => {
      resultBudgets.forEach((element) => {
        var nowtemp = new Date(element.created_date).getTime();
        var nownow = new Date().getTime();
        var diff = nownow - nowtemp;
        var diffDays = Math.ceil(diff / (24 * 3600 * 1000));

        if (element.dias > 60) {
          element.colorAviso = "r-rojo";
        }
        if (element.state === 6) {
          vigentes.push(element);
        }
        if (
          diffDays < 30 &&
          diffDays > 0 &&
          element.state != 6 &&
          element.state != 9
        ) {
          vigentes.push(element);
        }
      });

      this.settings.actions.custom = [];

      this.settings.actions.custom.push({
        name: "editar",
        title: `<div class="editCustomButton">Editar</div>`,
      });
      if (this.rolParaValidar == 4 || this.rolParaValidar == 5) {
        this.settings.actions.custom.push({
          name: "eliminar",
          title: `<div class="editCustomButton">Eliminar</div>`,
        });
        this.settings.actions.custom.push({
          name: "archivar",
          title: `<div class="editCustomButton">Archivar</div>`,
        });
      }

      this.getTableData(vigentes);
    });
  }

  cargarVencidos() {
    localStorage.setItem(
      "filter-budget",
      JSON.stringify(this.dataSourceBudgetHeader.getFilter())
    );
    this.todos_activo = false;
    this.vigentes_activo = false;
    this.vencidos_activo = true;
    this.showArchived = false;

    var vencidos = [];
    this.dataSourceBudgetHeader = [];

    this.budgetService.getBudgets().subscribe((resultBudgets: any) => {
      console.log("result ", resultBudgets);
      resultBudgets.forEach((element) => {
        var nowtemp = new Date(element.created_date).getTime();
        var nownow = new Date().getTime();
        var diff = nownow - nowtemp;
        var diffDays = Math.ceil(diff / (24 * 3600 * 1000));

        if (element.dias > 60) {
          element.colorAviso = "r-rojo";
        }
        if (diffDays > 30 && element.state != 6 && element.state != 9) {
          vencidos.push(element);
        }
      });

      this.settings.actions.custom = [];

      this.settings.actions.custom.push({
        name: "editar",
        title: `<div class="editCustomButton">Editar</div>`,
      });
      if (this.rolParaValidar == 4 || this.rolParaValidar == 5) {
        this.settings.actions.custom.push({
          name: "eliminar",
          title: `<div class="editCustomButton">Eliminar</div>`,
        });
        this.settings.actions.custom.push({
          name: "archivar",
          title: `<div class="editCustomButton">Archivar</div>`,
        });
      }

      this.getTableData(vencidos);
    });
  }

  cargarArchivados() {
    this.todos_activo = false;
    this.vigentes_activo = false;
    this.vencidos_activo = false;
    this.showArchived = true;
    var archivados = [];
    this.dataSourceBudgetHeader = [];

    this.budgetService.getBudgets().subscribe((resultBudgets: any) => {
      archivados = resultBudgets.filter((budget) => budget.state == 9);
      console.log(archivados);
      this.settings.actions.custom = [];

      if (this.rolParaValidar != 1) {
        this.settings.actions.custom.push({
          name: "desarchivar",
          title: `<div class="editCustomButton">Desarchivar</div>`,
        });
      }

      this.getTableData(archivados);
    });
  }

  exportExcel() {
    let headerData;
    let copyData;

    headerData = [
      { dataBound: "external_code", name: "Código", width: 40 },
      {
        dataBound: "work_order_external_code",
        name: "OT relacionada",
        width: 20,
      },
      { dataBound: "project", name: "Proyecto", width: 30 },
      { dataBound: "state_name", name: "Estado", width: 30 },
      { dataBound: "facts", name: "Factura", width: 30 },
      { dataBound: "client_name", name: "Cliente", width: 30 },

      {
        dataBound: "monto_usd",
        name: "Monto USD",
        width: 30,
        horizontal: "right",
      },
      {
        dataBound: "monto_pen",
        name: "Monto Soles",
        width: 30,
        horizontal: "right",
      },
      { dataBound: "user_name", name: "Creado por", width: 30 },
      { dataBound: "created_date", name: "Creado en", width: 30 },
    ];
    const data = this.dataSourceBudgetHeader.filteredAndSorted;
    copyData = this.dataSourceBudgetHeader.filteredAndSorted;
    const nameProyect = "Reporte hora por cliente";

    const options = {
      fieldSeparator: ";",
      quoteStrings: '"',
      decimalseparator: ".",
      showLabels: true,
      useBom: true,
      headers: [
        "Código",
        "OT relacionada",
        "Proyecto",
        "Estado",
        "Factura",
        "Cliente",
        "Monto",
      ],
    };
    this.reporteService
      .exportExcelBudget(headerData, copyData, this.montototal)
      .subscribe((result) => {
        const mediaType =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        const blob = new Blob([result._body], { type: mediaType });
        const fileName = "Reporte";
        fileSaver.saveAs(blob, fileName);
      });
  }

  copyObject(obj): object {
    return JSON.parse(JSON.stringify(obj));
  }

  async getTableData(result) {
    /*this.notifierService.systemNotify({
      title: 'Espere',
      message: 'Cargando presupuestos',
      type: 'info'
    });*/
    this.montototal = 0;
    const cloneRows: Array<any> = [...result];

    for (const item of cloneRows) {
      item.aperture_date = moment(item.aperture_date).format("DD/MM/YYYY");
      item.closed = item.closed === 1 ? "Cerrado" : "Abierto";
      for (const v of this.ldvStates) {
        // tslint:disable-next-line:triple-equals
        if (item.state == v.ref1) {
          item.state_name = v.value;
        }
      }

      this.montototal = this.montototal + item.total_amount;
      item.monto_final = Number(item.total_amount).toFixed(2);
      if (item.currency == "7") {
        item.monto_pen = Number(item.total_amount).toFixed(2);
        item.monto_usd = Number(0).toFixed(2);
      }
      if (item.currency == "8") {
        item.monto_usd = Number(item.total_amount).toFixed(2);
        item.monto_pen = Number(0).toFixed(2);
      }
    }

    this.dataSourceBudgetHeader = new LocalDataSource(cloneRows);
    this.tableSettingsBudgetHeader = this.copyObject(this.settings);

    if (this.tableDataBudgetHeader.columns !== undefined) {
      this.tableSettingsBudgetHeader.columns = this.copyObject(
        this.tableDataBudgetHeader.columns
      );

      this.tableSettingsBudgetHeader.columns.external_code.valuePrepareFunction =
        this.prepareProfilePicCell;
      this.tableSettingsBudgetHeader.columns.external_code.type = "html";

      this.tableSettingsBudgetHeader.columns.work_order_external_code.valuePrepareFunction =
        this.prepareProfilePicCell;
      this.tableSettingsBudgetHeader.columns.work_order_external_code.type =
        "html";

      this.tableSettingsBudgetHeader.columns.project.valuePrepareFunction =
        this.prepareProfilePicCell;
      this.tableSettingsBudgetHeader.columns.project.type = "html";

      this.tableSettingsBudgetHeader.columns.state_name.valuePrepareFunction =
        this.prepareProfilePicCell;
      this.tableSettingsBudgetHeader.columns.state_name.type = "html";

      this.tableSettingsBudgetHeader.columns.facts.valuePrepareFunction =
        this.prepareProfilePicCell;
      this.tableSettingsBudgetHeader.columns.facts.type = "html";

      this.tableSettingsBudgetHeader.columns.client_name.valuePrepareFunction =
        this.prepareProfilePicCell;
      this.tableSettingsBudgetHeader.columns.client_name.type = "html";

      this.tableSettingsBudgetHeader.columns.user_name.valuePrepareFunction =
        this.prepareProfilePicCell;
      this.tableSettingsBudgetHeader.columns.user_name.type = "html";

      this.tableSettingsBudgetHeader.columns.monto_final.valuePrepareFunction =
        this.prepareProfilePicCell;
      this.tableSettingsBudgetHeader.columns.monto_final.type = "html";

      /* this.tableSettingsBudgetHeader.columns.total_amount.valuePrepareFunction = this.prepareProfilePicCell; 
      this.tableSettingsBudgetHeader.columns.total_amount.type = 'html';
      

      this.tableSettingsBudgetHeader.columns["monto_final"] = {
        "title": this.tableSettingsBudgetHeader.columns["monto_final"].title, type: 'html', valuePrepareFunction: function (value) {
          return '<div class="numberformat"> ' + value + ' </div>'
        }
      };*/

      if (!this.tableSettingsBudgetHeader.columns["state_name"]) {
        Object.keys(this.tableSettingsBudgetHeader.columns).forEach((key) => {
          this.tableSettingsBudgetHeader.columns[key].filter = true;
        });
      }
    }

    if (
      localStorage.getItem("filter-budget") != "" &&
      localStorage.getItem("filter-budget")
    ) {
      var elem = JSON.parse(localStorage.getItem("filter-budget"));
      console.log(elem, cloneRows);
      if (cloneRows.length > 0) {
        this.dataSourceBudgetHeader.setFilter(elem.filters);
        localStorage.setItem("filter-budget", "");
      }
    }
  }

  private async getBillsOfBudget(budgetId) {
    try {
      return await this.billingService.getBillsByBudget(budgetId).toPromise();
    } catch (e) {
      throw e;
    }
  }

  customAction(event) {
    switch (event.action) {
      case "editar":
        localStorage.setItem(
          "filter-budget",
          JSON.stringify(this.dataSourceBudgetHeader.getFilter())
        );

        this.routes.navigate([
          "/system/budget/edit/" +
            event.data.work_order_id +
            "/" +
            event.data.id,
        ]);
        break;
      case "eliminar":
        const deleteDialog = this.dialog.open(AlertComponent, {
          data: {
            icon: "exclamation-circle",
            iconColor: "failure",
            title: "Aviso",
            text: "¿Está seguro que desea eliminar el Presupuesto?",
            options: true,
          },
        });
        deleteDialog.afterClosed().subscribe(
          (result) => {
            if (result) {
              // service delete
              this.budgetService.desactiveBudget(event.data.id).subscribe(
                (resultDesactive) => {
                  this.budgetService.getBudgets().subscribe((resultBudgets) => {
                    this.getTableData(resultBudgets);
                    this.notifierService.systemNotify({
                      title: "Éxito",
                      message: "Se ha eliminado el presupuesto",
                      type: "success",
                    });
                  });
                },
                (err) => {
                  this.notifierService.systemNotify({
                    title: "Ha ocurrido un error",
                    message:
                      "Por favor póngase en contacto con el administrador",
                    type: "error",
                  });
                }
              );
            }
          },
          (error) => {
            console.log("error", error);
          }
        );
        break;
      case "archivar":
        const archivarDialog = this.dialog.open(AlertComponent, {
          data: {
            icon: "exclamation-circle",
            iconColor: "failure",
            title: "Aviso",
            text: "¿Está seguro que desea archivar el Presupuesto?",
            options: true,
          },
        });
        archivarDialog.afterClosed().subscribe(
          (result) => {
            if (result) {
              let budgetupd = {...event.data};
              //console.log('budget update : ', budgetupd);
              
              if (!(budgetupd.state == 6 || budgetupd.state_name == 'FACTURADA')) {
                this.notifierService.systemNotify({
                  title: "Ha ocurrido un error",
                  message: 'El presupuesto debe estar FACTURADO para archivarlo',
                  type: "error",
                });
                return;
              } else {
                budgetupd.stateArchivado = budgetupd.state;
                budgetupd.state = 9;
                this.budgetService.updateBudget(budgetupd).subscribe((result) => {
                  this.notifierService.systemNotify({
                    title: "Éxito",
                    message: "Se ha archivado el presupuesto",
                    type: "success",
                  });
                  if (this.todos_activo) this.cargarTodos();
                  else if (this.vigentes_activo) this.cargarVigentes();
                  else if (this.vencidos_activo) this.cargarVencidos();
                }),
                  (err) => {
                    console.log("error", err);
                    this.notifierService.systemNotify({
                      title: "Ha ocurrido un error",
                      message:
                        "Por favor póngase en contacto con el administrador " +
                        err,
                      type: "error",
                    });
                  };
              }

            }
          },
          (error) => {
            console.log("error", error);
          }
        );
        break;
      case "desarchivar":
        const desarchivarDialog = this.dialog.open(AlertComponent, {
          data: {
            icon: "exclamation-circle",
            iconColor: "failure",
            title: "Aviso",
            text: "¿Está seguro que desea desarchivar el Presupuesto?",
            options: true,
          },
        });
        desarchivarDialog.afterClosed().subscribe(
          (result) => {
            if (result) {
              let budgetupd = event.data;
              budgetupd.state = budgetupd.stateArchivado;
              this.budgetService.updateBudget(budgetupd).subscribe((result) => {
                this.notifierService.systemNotify({
                  title: "Éxito",
                  message: "Se ha desarchivado el presupuesto",
                  type: "success",
                });
                this.cargarArchivados();
              }),
                (err) => {
                  console.log("error", err);
                  this.notifierService.systemNotify({
                    title: "Ha ocurrido un error",
                    message:
                      "Por favor póngase en contacto con el administrador " +
                      err,
                    type: "error",
                  });
                };
            }
          },
          (error) => {
            console.log("error", error);
          }
        );
        break;
    }
  }

  onUserRowSelect(event) {
    this.selectedRows = event.selected;
    console.log("e", event);
  }

  archivarMultiple() {
    var n = this.selectedRows.length;
    // It will console all the selected rows
    if (n == 0) {
      const aviso = this.dialog.open(AlertComponent, {
        data: {
          icon: "exclamation-circle",
          iconColor: "failure",
          title: "Aviso",
          text: "Seleccione mínimo un documento",
          options: false,
        },
      });
      aviso.afterClosed().subscribe((_) => {});
      return;
    }

    const archivarDialog = this.dialog.open(AlertComponent, {
      data: {
        icon: "exclamation-circle",
        iconColor: "failure",
        title: "Aviso",
        text: "¿Está seguro que desea archivar los " + n + " presupuestos?",
        options: true,
      },
    });

    archivarDialog.afterClosed().subscribe(
      (result) => {
        if (result) {

          if (!(this.selectedRows && this.selectedRows.length > 0)) {
            this.notifierService.systemNotify({
              title: "Ha ocurrido un error",
              message: 'Por favor seleccione presupuestos facturados para archivar',
              type: "error",
            });
            return;
          }

          if (this.selectedRows.some( (pres) => pres.state != 6 )) {
            this.notifierService.systemNotify({
              title: "Ha ocurrido un error",
              message: 'Seleccione solo presupuestos facturados para archivar',
              type: "error",
            });
            return;
          }

          this.budgetService
            .updateBudgetArray(this.selectedRows)
            .subscribe((result) => {
              console.log(result);
              console.log(this.selectedRows);
              this.notifierService.systemNotify({
                title: "Éxito",
                message: "Se han archivado los presupuestos",
                type: "success",
              });
              if (this.todos_activo) this.cargarTodos();
              else if (this.vigentes_activo) this.cargarVigentes();
              else if (this.vencidos_activo) this.cargarVencidos();
            }),
            (err) => {
              console.log("error", err);
              this.notifierService.systemNotify({
                title: "Ha ocurrido un error",
                message:
                  "Por favor póngase en contacto con el administrador " + err,
                type: "error",
              });
            };
        }
      },
      (error) => {
        console.log("error", error);
      }
    );
  }

  prepareProfilePicCell(cell, row): string {
    if (cell) {
      return `<div class='text-rigth ${row.colorAviso}'>${cell}</div>`;
    } else {
      return "";
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/system/budget/budget-list/budget-list.component..ts